(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/iframe-container/render"] = factory();
	else
		root["/fego/component/iframe-container/render"] = factory();
})(self, () => {
return 